import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <div className="luxury-wrapper">
        {/* Top Header Label */}
        <div className="gold-header-banner">
          BAYT AL-KHAYR ◆ EST. 2026 ◆ MEDINA
        </div>

        {/* Main Hero Header */}
        <div className="about-hero-title">
          <h1>ABOUT US</h1>
          <p className="subtitle">Serving the World — Ethically. Authentically. Globally.</p>
          <p className="tagline">Every Product, A Piece of Khayr for Your Home.</p>
        </div>

        {/* Main Content Layout */}
        <div className="about-main-grid">
          {/* Left Column: Our Story & Timeline */}
          <div className="about-left-col">
            <div className="ornate-section-card">
              <h2 className="gold-section-title">OUR STORY</h2>
              <p className="story-text">
                Founded in 2026 in Medina, Bayt Al-Khayr was born to bring the finest halal-certified essentials to homes around the world. Rooted in tradition and crafted for the modern era, we source premium, sustainably made products that uphold quality, integrity, and compassion. From the historic city of Medina, each item is carefully curated to meet the highest standards of halal certification — honoring heritage while meeting today's needs for conscious living.
              </p>
            </div>

            <div className="ornate-box-timeline">
              <h3 className="timeline-title">TIMELINE — 2026</h3>
              <ul className="timeline-events">
                <li><strong>2026 • MEDINA</strong></li>
                <li>Bayt Al-Khayr founded in Medina dedicated to global halal excellence.</li>
              </ul>
            </div>
          </div>

          {/* Right Column: Founder & Global Shipping */}
          <div className="about-right-col">
            <div className="ornate-section-card center-align">
              <h2 className="gold-section-title">FOUNDER & CEO</h2>
              <blockquote className="founder-quote">
                "Our promise is to serve with integrity, quality, and care — for every home, everywhere."
              </blockquote>

              <h2 className="gold-section-title underline-title">GLOBAL SHIPPING</h2>

              <div className="map-illustration">
                <svg className="world-map-svg" viewBox="0 0 1000 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M150,120 Q180,100 220,130 T280,150 T310,210 T250,250 T180,220 Z" fill="rgba(212,175,55,0.15)" stroke="#d4af37" strokeWidth="1.5" />
                  <path d="M450,100 Q500,80 580,110 T620,180 T550,220 T480,160 Z" fill="rgba(212,175,55,0.15)" stroke="#d4af37" strokeWidth="1.5" />
                  <path d="M480,240 Q530,220 580,260 T560,380 T500,400 T460,310 Z" fill="rgba(212,175,55,0.15)" stroke="#d4af37" strokeWidth="1.5" />
                  <path d="M650,80 Q750,60 880,100 T920,220 T800,280 T680,180 Z" fill="rgba(212,175,55,0.15)" stroke="#d4af37" strokeWidth="1.5" />
                  <path d="M780,320 Q840,300 900,340 T880,420 T810,410 Z" fill="rgba(212,175,55,0.15)" stroke="#d4af37" strokeWidth="1.5" />
                  {/* Glowing map nodes */}
                  <circle cx="200" cy="140" r="4" fill="#ffd700" />
                  <circle cx="500" cy="120" r="4" fill="#ffd700" />
                  <circle cx="520" cy="280" r="4" fill="#ffd700" />
                  <circle cx="750" cy="110" r="4" fill="#ffd700" />
                  <circle cx="850" cy="350" r="4" fill="#ffd700" />
                </svg>
              </div>

              <p className="global-text">Shipping to over 60+ countries worldwide</p>
              <p className="sub-global-text">• Trusted by customers globally.</p>
            </div>
          </div>
        </div>

        {/* Bottom Feature Badges Bar */}
        <div className="bottom-badges-grid">
          <div className="badge-card">
            <div className="badge-icon-hex">
              <span>★</span>
            </div>
            <div className="badge-text">
              <h4>HALAL CERTIFIED</h4>
              <p>Certified & Compliant</p>
            </div>
          </div>

          <div className="badge-card">
            <div className="badge-icon-lotus">
              <span>🌿</span>
            </div>
            <div className="badge-text">
              <h4>PREMIUM QUALITY</h4>
              <p>Ethically Sourced • Sustainable • Lab Tested</p>
            </div>
          </div>

          <div className="badge-card">
            <div className="badge-icon-shield">
              <span>�️</span>
            </div>
            <div className="badge-text">
              <h4>SHOP WITH CONFIDENCE</h4>
              <p>Secure Checkout • 30-Day Guarantee</p>
            </div>
          </div>
        </div>

        {/* Footer Sub-banner */}
        <div className="gold-footer-banner">
          Bayt Al-Khayr © 2026 • Medina, Saudi Arabia • Serving the World Globally • Halal | Ethical | Global
        </div>
      </div>
    </div>
  );
}

export default About;
